// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badge {
  background-color: var(--ion-color-secondary);
  position: relative;
  top: -10px;
  right: 16px;
  border-radius: 50%;
  height: 0.8rem;
  width: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.badge .text {
  font-size: 0.6rem;
}

.icono-carrito {
  height: 1.8rem;
  width: 1.8rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/custom-cart-button/custom-cart-button.component.scss"],"names":[],"mappings":"AAAA;EACI,4CAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;AAAI;EACI,iBAAA;AAER;;AAEA;EACI,cAAA;EACA,aAAA;AACJ","sourcesContent":[".badge{\n    background-color: var(--ion-color-secondary);\n    position: relative;\n    top:-10px;\n    right:16px;\n    border-radius: 50%;\n    height: 0.8rem;\n    width: 0.8rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    .text{\n        font-size:0.6rem;\n    }\n}\n\n.icono-carrito{\n    height: 1.8rem;\n    width: 1.8rem;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
